import React, { Component } from 'react';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

class Modal extends Component {
  state = {
    maxHeight: window.innerHeight,
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
    window.removeEventListener('keydown', this.handleKeyPress, false);
  }

  handleClick = event => {
    // Close the modal if the background is clicked
    // $ is required as IE11 doesn't support native .closest()
    if ($(event.target).closest('.modal-wrapper').length === 0) {
      this.props.onClose();
    }
  };

  handleResize = debounce(() => {
    this.setState({ maxHeight: window.innerHeight });
  }, 500);

  handleKeyPress = event => {
    // On escape
    if (event.keyCode === 27) {
      this.props.onClose();
    }
  };

  get modalMaxHeight() {
    if (!this.props.maxHeight) {
      return this.state.maxHeight - 32;
    }

    return Math.min(this.props.maxHeight, this.state.maxHeight) - 32;
  }

  render() {
    if (!this.props.open) return null;

    const { turnOffBackgroundClose } = this.props;

    const onClick = !turnOffBackgroundClose ? this.handleClick : undefined;

    const modalBackgroundProps = {
      className:
        'modal-background d-flex align-items-center h-100 w-100 position-fixed',
      onClick,
      style: {
        overflow: 'scroll', // for mWeb Android ability to scroll envelope address modal
        maxHeight: this.state.maxHeight,
      },
    };

    const modalProps = {
      className: 'modal-wrapper d-flex flex-column',
      style: {
        maxHeight: this.modalMaxHeight,
        maxWidth: this.props.maxWidth ? `${this.props.maxWidth}px` : '100%',
      },
    };

    const $title = (({ title }) => {
      if (title && typeof title === 'string' && title) {
        return <p className="lead">{title}</p>;
      }

      return title;
    })(this.props);

    return (
      <FocusTrap>
        <div
          {...modalBackgroundProps}
          data-test-id="modal-background">
          <div
            {...modalProps}
            role={this.props.actions ? 'dialog' : 'alert'}
            aria-describedby="modal_title"
            aria-modal="true"
            aria-hidden={!this.props.open}
          >
            <div
              className={classNames(
                'd-flex flex-column text-left',
                this.props.className
              )}>
              {this.props.close && (
                <div className="heading clearfix close-modal">
                  <button
                    className="close float-right"
                    aria-label="Close"
                    onClick={this.props.onClose}>
                    <i className="skinny-icon close" />
                  </button>
                </div>
              )}
              <div role="heading" aria-level="2" className="modal-title" id="modal_title">{$title}</div>
              <div className="modal-body">{this.props.children}</div>
              <div
                className={classNames('modal-actions', {
                  'd-none': !this.props.actions,
                })}>
                {this.props.actions}
              </div>
            </div>
          </div>
        </div>
      </FocusTrap>
    );
  }
}

Modal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.bool,
  actions: PropTypes.element,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  turnOffBackgroundClose: PropTypes.bool,
};

Modal.defaultProps = {
  turnOffBackgroundClose: null,
};

export default Modal;
